import * as React from 'react';
import Regions from '@ui/scenes/Regions';

const RegionsPage = () => (
  <div className="countries-page">
    <Regions />
  </div>
);

export default RegionsPage;



// WEBPACK FOOTER //
// ./src/pages/Regions/Regions.tsx